import type { Router } from 'vue-router'
import { shokzRoutes } from './shokz-routes'

/** 韶音路由挂载到「客户中心」菜单组（name=Customer），不修改 routes.ts */
const SHOKZ_PARENT_ROUTE_NAME = 'Customer'

/**
 * 动态注册韶音/MDM 路由（权限路由加载后调用；可重复调用，登出重登后自动补注册）
 */
export function ensureShokzRoutes(router: Router): boolean {
  if (!router.hasRoute(SHOKZ_PARENT_ROUTE_NAME)) {
    return false
  }
  for (const route of shokzRoutes) {
    const name = route.name as string
    if (!router.hasRoute(name)) {
      router.addRoute(SHOKZ_PARENT_ROUTE_NAME, route)
    }
  }
  return true
}
